import { useDocumentTitle } from '@/shared/hooks';
import { ACCOUNT_ACCENT } from './accountStyles';

const tips = [
  {
    title: 'How to order leads',
    body: 'Use Premium Leads for fresh in-territory opportunities at standard pricing, and Clearance for older discounted opportunities.'
  },
  {
    title: 'Auto-purchasing basics',
    body: 'Enable auto-purchase from Dashboard > Plan & pricing. Keep territory and FSAs up to date so matching can happen immediately when new leads arrive.'
  },
  {
    title: 'Maintain wallet balance',
    body: 'Auto-purchase and manual checkout both require available wallet funds. Keep a buffer above your Buyer Lead and Tenant Lead prices to avoid missed assignments.'
  },
  {
    title: 'Manual purchasing in Clearance',
    body: 'Clearance defaults to leads in your territory; use the toggle to include outside-territory inventory. Select leads and check out from your wallet at the discounted price.'
  },
  {
    title: 'What is a Clearance lead?',
    body: 'A Clearance lead is older inventory that is no longer fresh routing inventory and is sold at a lower price.'
  },
  {
    title: 'Territory best practices',
    body: 'Use radius and generated FSAs as a starting point, then review and edit the FSA list manually for precise coverage in your target markets.'
  }
];

const AccountHelpCenterPage = () => {
  useDocumentTitle('Help Center - BrokerMax');

  return (
    <div className="mx-auto max-w-5xl space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">
          Help Center
        </h1>
        <p className="mt-1 max-w-2xl text-sm text-slate-700">
          Quick guidance for ordering leads, auto-purchase setup, wallet
          management, and territory coverage.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        {tips.map(item => (
          <section
            key={item.title}
            className={`rounded-xl border border-slate-200/80 p-5 shadow-sm ${ACCOUNT_ACCENT.cardSurface}`}
          >
            <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">
              {item.title}
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-slate-700">
              {item.body}
            </p>
          </section>
        ))}
      </div>
    </div>
  );
};

export default AccountHelpCenterPage;
